export default __webpack_public_path__ + "static/media/red-baggage.80812f27.svg";